import { Skeleton, Typography } from '@mui/material'
import { generatePhoneFromString } from 'components-ui'
import { useEffect, useState } from 'react'
import { UserClientDto, UserProfileClientDto } from 'service-api/src/types'
import { AccountHolderForm } from '../account_holder_form'
import { Card, CardContainer, CardsListContainer } from './common'
import { i18WithParams as t } from '@shared/locale'

type AccountHolderCardProps = {
  user?: UserClientDto
}

export const AccountHolderCard = (props: AccountHolderCardProps) => {
  const [editMode, setEditMode] = useState(false)
  const [user, setUser] = useState<UserClientDto>()

  useEffect(() => {
    setUser(props.user)
  }, [props.user])

  if (!user)
    return (
      <CardsListContainer>
        <Skeleton variant="rounded" width={349} height={248} />
      </CardsListContainer>
    )

  if (!user.userProfile) return null

  const { email } = user
  const { firstName, lastName, phone, streetAddress, streetAddress2 } = user.userProfile[0]

  const bodyLines = [
    `${firstName} ${lastName}`,
    generatePhoneFromString(phone || ''),
    email,
    streetAddress,
    streetAddress2,
  ].filter((data) => data && data?.trim() !== '') as string[]

  const handleEditClick = () => {
    setEditMode(true)
  }

  const onCancel = () => {
    setEditMode(false)
  }

  const onSave = (newUserProfile: UserProfileClientDto) => {
    setUser((prevUser) => ({ ...prevUser, userProfile: [newUserProfile] }))
    setEditMode(false)
  }

  return (
    <CardsListContainer>
      <CardContainer>
        {editMode ? (
          <AccountHolderForm onCancel={onCancel} onSave={onSave} user={user} />
        ) : (
          <Card title={t('manageAccount.people.accountHolder')} onEditClick={handleEditClick}>
            {bodyLines?.map((line) => (
              <Typography key={line} variant="body1">
                {line}
              </Typography>
            ))}
          </Card>
        )}
      </CardContainer>
    </CardsListContainer>
  )
}

export default AccountHolderCard
